import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ActionPopOver } from './action-pop-over';

@NgModule({
  declarations: [ActionPopOver],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    IonicModule,
  ],
  entryComponents: [ActionPopOver],
})
export class ActionPopOverModule { }
